import React from 'react';
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Phone, Mail, MapPin, Instagram, Facebook } from 'lucide-react';

const ContactSection: React.FC = () => {
  return (
    <section id="contact" className="section-padding bg-white">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <h2 className="mb-4 bg-gradient-to-r from-sage-600 to-amber-500 bg-clip-text text-transparent">Contact Us</h2>
          <p className="max-w-3xl mx-auto text-lg text-gray-700">
            We're here to answer your questions and help you begin your wellness journey.
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8">
          <Card className="rounded-2xl overflow-hidden shadow-lg border-2 border-amber-200/30">
            <CardContent className="p-8 flex flex-col items-center text-center">
              <div className="h-12 w-12 rounded-full bg-sage-100 flex items-center justify-center text-sage-700 mb-4 border-4 border-gold-500">
                <Phone className="h-6 w-6" />
              </div>
              <h3 className="text-xl font-serif font-medium mb-2 text-sage-800">Call Us</h3>
              <p className="text-gray-700 mb-4">Speak directly with our team</p>
              <Button className="btn-outline" size="lg" asChild>
                <a href="tel:0415537784">0415 537 784</a>
              </Button>
            </CardContent>
          </Card>

          <Card className="rounded-2xl overflow-hidden shadow-lg border-2 border-amber-200/30">
            <CardContent className="p-8 flex flex-col items-center text-center">
              <div className="h-12 w-12 rounded-full bg-sage-100 flex items-center justify-center text-sage-700 mb-4 border-4 border-gold-500">
                <Mail className="h-6 w-6" />
              </div>
              <h3 className="text-xl font-serif font-medium mb-2 text-sage-800">Email Us</h3>
              <p className="text-gray-700 mb-4">Send us your questions or inquiries</p>
              <Button className="btn-outline" size="lg" asChild>
                <a href="mailto:womenandtheway@gmail.com">Email Now</a>
              </Button>
            </CardContent>
          </Card>

          <Card className="rounded-2xl overflow-hidden shadow-lg border-2 border-amber-200/30">
            <CardContent className="p-8 flex flex-col items-center text-center">
              <div className="h-12 w-12 rounded-full bg-sage-100 flex items-center justify-center text-sage-700 mb-4 border-4 border-gold-500">
                <MapPin className="h-6 w-6" />
              </div>
              <h3 className="text-xl font-serif font-medium mb-2 text-sage-800">Visit Us</h3>
              <p className="text-gray-700 mb-4">Find us at 2/700 Nicklin Way, Currimundi, Qld</p>
              <Button className="btn-outline" size="lg" asChild>
                <a href="https://maps.app.goo.gl/rsyoGVmEb6Ydtat7A" target="_blank" rel="noopener noreferrer">Get Directions</a>
              </Button>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
